module.exports = __webpack_public_path__ + "static/media/ordkedjor_brajobbat.498ad56b.mp3";